import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { Eye } from 'react-bootstrap-icons'
import { BrowseContext } from '../../../contexts/BrowseContext'
import FoldersList from './FoldersList'
import ClientCampaignsList from './ClientCampaignsList'
import KpiMetricsRow from './CampaignsBrowseParts/KpiMetricsRow'
import { CLIENT_PAGE_GUTTER } from './CampaignsBrowseParts/clientPageLayout'

export default observer(function ClientSummaryTab() {
  const { clientCampaigns } = useContext(BrowseContext)

  return (
    <div className="w-full pb-8">
      <div className={`${CLIENT_PAGE_GUTTER} py-6`}>
        <KpiMetricsRow
          campaigns={clientCampaigns}
          budgetTitle="Total Budget"
          BudgetIcon={Eye}
          layout="grid"
        />
      </div>
      <FoldersList />
      <ClientCampaignsList />
    </div>
  )
})
